var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgToggleIcon = function SvgToggleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.00017,
    cy: 3,
    rx: 3.00017,
    ry: 3,
    transform: "matrix(0.707107 0.707107 -0.707222 0.706992 14.1406 4.24219)",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4285 4.77314C12.4787 2.72281 15.8027 2.72274 17.853 4.77299C19.9032 6.82325 19.9033 10.1474 17.8531 12.1978L12.1965 17.8548C10.1463 19.9052 6.82227 19.9053 4.77201 17.855C2.72176 15.8047 2.72169 12.4806 4.77186 10.4302L10.4285 4.77314Z",
    stroke: "currentColor",
    strokeOpacity: 0.6,
    strokeWidth: 1.5
  })));
};
export default SvgToggleIcon;